import { useAuthContext } from 'contexts/auth'

interface PermissionGateProps {
    children: JSX.Element
    permissions: string[]
}

const hasPermission = (permissions: string[]) => {
    const { permissionArray } = useAuthContext()

    if (
        permissions.every(permission => {
            return permissionArray?.includes(permission)
        })
    ) {
        return true
    }
    return false
}

const hasPermissionBeforeLog = (
    permissions: string[],
    currentPermissions: string[]
) => {
    if (
        permissions.every(permission => {
            return currentPermissions?.includes(permission)
        })
    ) {
        return true
    }
    return false
}

const PermissionGate = ({ children, permissions }: PermissionGateProps) => {
    if (hasPermission(permissions)) {
        return <>{children}</>
    }

    return null
}

export { PermissionGate, hasPermission, hasPermissionBeforeLog }
